import React, { useEffect } from 'react';
import styles from './MusicBuskAlbum.module.css';

const BUSK_EMBED_ORIGIN =
  process.env.REACT_APP_BUSK_EMBED_ORIGIN || 'https://www.buskmusic.com';
const BUSK_ALBUM_ID = 'c54209dc-f673-470b-a70a-8d702f165a9f';
const BUSK_ART_URL =
  'https://buskphotos.s3.us-west-2.amazonaws.com/albumpic/98eea509-7f74-456c-b174-ba92d43061f0-Bill Evans - How My Heart Sings.jpeg?timestamp=1773464956334';

const MusicBuskAlbum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const params = new URLSearchParams({
    theme: 'dark',
    accent: 'black',
    size: 'standard',
    downloads: '0',
    rights: 'public',
    artUrl: BUSK_ART_URL,
  });
  const src = `${BUSK_EMBED_ORIGIN}/embed/album/${BUSK_ALBUM_ID}?${params.toString()}`;

  return (
    <div className={styles.wrap}>
      <iframe
        className={styles.iframe}
        src={src}
        width="100%"
        height="300"
        title="Busk embedded album player"
        loading="lazy"
        allow="autoplay; encrypted-media"
      />
    </div>
  );
};

export default MusicBuskAlbum;
